import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Header, Loader, Table } from 'semantic-ui-react';
import agent from '../../app/api/agent';
import { toast } from 'react-toastify';
import { smartDeleteListData } from '../../app/models/Restoration';

const MultipleDeleteOption = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [assignTitleCode, setAssignTitleCode] = useState<{ key: string; text: string; value: string }[]>([]);
  const [selectedTitle, setSelectedTitle] = useState<string>('');
  const [tabledata, setTableData] = useState<smartDeleteListData[]>([]);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);

  useEffect(() => {
    const fetchTitleCodes = async () => {
      try {
        const response = await agent.SmartTracker.titleCodeGet();
        const options = response.data.map((index: any) => ({
          key: index, text: index, value: index,
        }));
        setAssignTitleCode(options);
      } catch (error) {
        toast.error('Error fetching title code');
      }
    };

    fetchTitleCodes();
  }, []);

  const handleChangeTitle = async (e: React.SyntheticEvent<HTMLElement>, data: any) => {
    setSelectedTitle(data.value as string);
  };

  const handleCheckboxChange = (item: any) => {
    setSelectedItems(prevSelected => {
      if (prevSelected.includes(item.id)) {
        return prevSelected.filter(i => i !== item.id); 
      } else {
        return [...prevSelected, item.id]; 
      }
    });
  };


  const multipleDelete = async () => {
    if (selectedItems.length === 0) {
      toast.error('Please select at least one item to delete');
      return;
    }
    setLoading(true); 
    try {
      const deleteDetailsPromises = selectedItems.map(async (itemId) => {
        const response = await agent.manageAssetPage.itemDeleteDetails({ itemId }); 
        return response.data; 
      });
      const deleteDetailsList = await Promise.all(deleteDetailsPromises);
      const deletePromises = deleteDetailsList.map((deleteDetails: any) => {
        return agent.manageAssetPage.itemDelete(deleteDetails); 
      });
  
      await Promise.all(deletePromises);
      toast.success('Selected items have been deleted successfully');
      setSelectedItems([]); 
      setTableData([]); 
    } catch (error) { 
      toast.error('Error deleting items');
    } finally {
      setLoading(false); 
    }
  };
  
  const handleTableData = async () => {
    if (!selectedTitle) {
      toast.error('Please select a title code first');
      return;
    }

    setLoading(true);
    try {
      const response = await agent.SmartTracker.smartDeleteList(selectedTitle);
      setTableData(response.data);
    } catch (error) {
      toast.error('Error fetching table data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='title_wise_cutlistreport'>
      <Header>Multi Cutlist Delete</Header>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <div style={{ marginRight: '10px' }}>
          <label style={{ fontWeight: 'bold' }}>Title Code</label>
          <Dropdown
            clearable
            placeholder="Select title code"
            fluid
            selection
            options={assignTitleCode}
            value={selectedTitle}
            onChange={handleChangeTitle}
            style={{ width: '250px' }}
          />
        </div>
        {selectedTitle && (
            <>
              <div style={{ marginRight: '10px', alignSelf: 'end'}}>
                <Button onClick={handleTableData} primary>View</Button>
              </div>
              <div style={{ marginRight: '10px', alignSelf: 'end'}}>
                <Button onClick={multipleDelete} negative>Delete</Button>
              </div>
            </>
        )}
      </div>

      {loading ? (
        <Loader active inline='centered' />
      ) : (
        <>
          {selectedTitle && (
            <div style={{ overflow: 'auto', border: '1px solid #ccc', borderRadius: '5px', padding: '10px' }}>
              <Table celled selectable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>{'  '}</Table.HeaderCell>
                    <Table.HeaderCell>Title Code</Table.HeaderCell>
                    <Table.HeaderCell>Shot Name</Table.HeaderCell>
                    <Table.HeaderCell>Start Frame</Table.HeaderCell>
                    <Table.HeaderCell>End Frame</Table.HeaderCell>
                    <Table.HeaderCell>Total Frame</Table.HeaderCell>
                    <Table.HeaderCell>Current Subtask</Table.HeaderCell>
                    <Table.HeaderCell>Status</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {tabledata.length === 0 && (
                    <Table.Row>
                      <Table.Cell colSpan={8} textAlign='center'>No data available</Table.Cell>
                    </Table.Row>
                  )}
                  {tabledata.map((item) => (
                    <Table.Row key={item.id}>
                      <Table.Cell>
                        <input
                          type='checkbox'
                          onClick={() => handleCheckboxChange(item)}
                          checked={selectedItems.includes(item.id)} // Use item.id here
                          style={{ alignSelf: 'center' }}
                        />
                      </Table.Cell>
                      <Table.Cell>{item.title_Code}</Table.Cell>
                      <Table.Cell>{item.shot_Name}</Table.Cell>
                      <Table.Cell>{item.start_Number}</Table.Cell>
                      <Table.Cell>{item.end_Number}</Table.Cell>
                      <Table.Cell>{item.total_Number}</Table.Cell>
                      <Table.Cell>{item.current_SubTask}</Table.Cell>
                      <Table.Cell>{item.status}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MultipleDeleteOption;
